import catalogStyles from '../sass/catalog.scss';
import filterGroupJS from './includes/filter_group';
import mobileFilterControls from './includes/mobile_filter_controls';

import catalogRoot1IMG from '../img/catalog-root-1.jpg';
import catalogRoot2IMG from '../img/catalog-root-2.jpg';
import catalogRoot3IMG from '../img/catalog-root-3.jpg';
import catalogRoot4IMG from '../img/catalog-root-4.jpg';
import catalogRoot5IMG from '../img/catalog-root-5.jpg';
import catalogRoot6IMG from '../img/catalog-root-6.jpg';
import catalogRoot7IMG from '../img/catalog-root-7.jpg';
import catalogRoot8IMG from '../img/catalog-root-8.jpg';
import catalogRoot9IMG from '../img/catalog-root-9.jpg';
import catalogRoot10IMG from '../img/catalog-root-10.jpg';

import catalogItem4IMG from '../img/catalog-item-4.jpg';
import catalogItem5IMG from '../img/catalog-item-5.jpg';
import catalogItem6IMG from '../img/catalog-item-6.jpg';
import catalogItem7IMG from '../img/catalog-item-7.jpg';
import catalogItem8IMG from '../img/catalog-item-8.jpg';
import catalogItem9IMG from '../img/catalog-item-9.jpg';
import catalogItem10IMG from '../img/catalog-item-10.jpg';
import catalogItem11IMG from '../img/catalog-item-11.jpg';
import catalogItem12IMG from '../img/catalog-item-12.jpg';
